module.exports = __webpack_public_path__ + "static/img/bg-xiuxi.be518a32.png";